import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { EditableElement } from 'mailup-web-components'

import { panelAddRecipientChangeDynamicFieldCallback } from 'Pages/RecipientsList/recoil/callbacks/addRecipient'
import { panelAddRecipientGetFieldValueState } from 'Pages/RecipientsList/recoil/state/addRecipient'

interface InputAddFieldProps {
  fieldId: number
}

const InputAddField: FC<InputAddFieldProps> = ({ fieldId }) => {
  const intl = useIntl()

  const value = useRecoilValue(panelAddRecipientGetFieldValueState(fieldId))

  const changeDynamicField = useRecoilCallback(
    panelAddRecipientChangeDynamicFieldCallback,
    [],
  )

  const handleChange = (v: string): void => {
    void changeDynamicField(fieldId, v)
  }

  return (
    <EditableElement
      value={value}
      onChange={handleChange}
      placeholder={intl.formatMessage({
        id: 'Load.RecipientsList.InputFieldPlaceholder',
      })}
      multiline
      maxLength={200}
    />
  )
}

export default InputAddField
